import type { NextPage } from 'next'
import { Glossary } from '@/client/modules/Glossary'
import { GlossaryProps } from '@/client/modules/Glossary/types'
import { getCMSContent } from '@/client/utils'

const GlossaryPage: NextPage<GlossaryProps> = (data) => <Glossary {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'GLOSSARY')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default GlossaryPage
